<template>
  <div class="container">
    <div class="order_detail_top"
      v-if="detail.order_status != 5">
      <el-steps :active="order_step"
        align-center
        simple
        finish-status="finish">
        <el-step v-for="(item, index) in stepList"
          :key="'s' + index"
          :title="item.title">
        </el-step>
      </el-steps>
    </div>

    <div class="main_order_detail">
      <div class="order_status">
        <i class="el-icon-warning"></i>
        <span class="current_order_status"
          v-if="detail.order_status == 0">当前订单状态: &nbsp;&nbsp;待付款</span>
        <span class="current_order_status"
          v-if="detail.order_status == 1">当前订单状态: &nbsp;&nbsp;已支付待发货</span>
        <span class="current_order_status"
          v-if="detail.order_status == 2">当前订单状态: &nbsp;&nbsp;已发货待收货</span>
        <span class="current_order_status"
          v-if="detail.order_status == 6">当前订单状态: &nbsp;&nbsp;已签收</span>
        <span class="current_order_status"
          v-if="detail.order_status == 7">当前订单状态: &nbsp;&nbsp;已收货</span>
        <span class="current_order_status"
          v-if="detail.order_status == 3">当前订单状态: &nbsp;&nbsp;已取消</span>
        <span class="current_order_status"
          v-if="detail.order_status == 4">当前订单状态: &nbsp;&nbsp;已完成</span>
        <span class="current_order_status"
          v-if="detail.order_status == 5">当前订单状态: &nbsp;&nbsp;已关闭</span>

        <el-button size="mini"
          style="float:right;margin-top:20px;margin-right:12px;"
          @click="createRemark">备注订单</el-button>
        <!--		v-if="detail.order_status == 0"-->
        <el-button size="mini"
          v-if="detail.order_status == 0 || detail.order_status == 1"
          style="float:right;margin-top:20px;margin-right:12px;"
          @click="endOrder">关闭订单</el-button>

        <el-button size="mini"
          v-if="detail.order_status == 1"
          style="float:right;margin-top:20px;margin-right:12px;"
          @click="certainPushWoods">确认发货</el-button>

        <el-button size="mini"
          v-if="detail.order_status == 7 || detail.order_status == 4 || detail.order_status == 2 || detail.order_status == 6 "
          style="float:right;margin-top:20px;margin-right:12px;"
          @click="trackWuliuInfo">物流轨迹跟踪</el-button>

        <el-button size="mini"
          v-if="detail.order_status == 4 || detail.order_status == 2 "
          style="float:right;margin-top:20px;margin-right:12px;"
          :disabled="detail.after_sale_status != 0"
          @click="applyAferSale">申请维权</el-button>
      </div>

      <div class="order_base_info">
        <div style="margin-bottom:24px;">
          <i class="el-icon-collection-tag"></i>
          <span class="top_title">基本信息</span>
        </div>

        <el-table border
          :data="baseInfoData"
          :cell-style="tc"
          :header-cell-style="tccolor"
          size="mini"
          style="width: 100%;margin-top:38px;">
          <el-table-column label="订单编号"
            prop="order_no"></el-table-column>
          <!-- <el-table-column label="用户账号">
            <template slot-scope="scope">
              <p v-if="scope.row.buyer_phone">{{ scope.row.buyer_phone }}</p>
              <p v-else>---</p>
            </template>
          </el-table-column> -->
          <el-table-column label="提交时间"
            prop="created_at"></el-table-column>
          <el-table-column label="物流运费">
            <template slot-scope="scope">
              <p v-if="scope.row.money_carriage">¥ {{ scope.row.money_carriage }}</p>
              <p v-else>---</p>
            </template>
          </el-table-column>
          <el-table-column label="订单金额(实付)"
            prop="moeny_pay">
            <template slot-scope="scope">
              <p v-if="scope.row.moeny_pay">¥ {{ scope.row.moeny_pay }}</p>
              <p v-else>---</p>
            </template>
          </el-table-column>
          <el-table-column label="订单总金额">
            <template slot-scope="scope">
              <p v-if="scope.row.money_total">¥ {{ scope.row.money_total }}</p>
              <p v-else>---</p>
            </template>
          </el-table-column>
          <!-- <el-table-column label="支付方式">---</el-table-column> -->
          <el-table-column label="订单主渠道">
            <template slot-scope="scope">
              <p v-if="scope.row.partner_name">{{ scope.row.partner_name }}</p>
              <p v-else>---</p>
            </template>
          </el-table-column>
          <el-table-column label="订单子渠道">
            <template slot-scope="scope">
              <p v-if="scope.row.agency_name">{{ scope.row.agency_name }}</p>
              <p v-else>---</p>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div class="order_base_info">
        <div style="margin-bottom:24px;">
          <i class="el-icon-collection-tag"></i>
          <span class="top_title">收货人信息</span>
        </div>

        <el-table border
          :data="userInfoData"
          :cell-style="tc"
          :header-cell-style="tccolor"
          size="mini"
          style="width: 100%;margin-top:38px;">
          <el-table-column label="收货人">
            <template slot-scope="scope">
              <p v-if="scope.row.contact_name">{{ scope.row.contact_name }}</p>
              <p v-else>---</p>
            </template>
          </el-table-column>
          <el-table-column label="联系电话">
            <template slot-scope="scope">
              <p v-if="scope.row.contact_phone">
                {{ scope.row.contact_phone }}
              </p>
              <p v-else>---</p>
            </template>
          </el-table-column>
          <!-- <el-table-column label="邮政编码">
            <template slot-scope="scope">
              <p v-if="scope.row.adcode">{{ scope.row.adcode }}</p>
              <p v-else>---</p>
            </template>
          </el-table-column> -->
          <el-table-column label="收获地址">
            <template slot-scope="scope">
              <p v-if="scope.row.address">
                {{ scope.row.province }}.{{ scope.row.city }}.{{
									scope.row.area
								}}.{{ scope.row.address }}
              </p>
              <p v-else>---</p>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div class="order_base_info">
        <div style="margin-bottom:24px;">
          <i class="el-icon-collection-tag"></i>
          <span class="top_title">商品信息</span>
        </div>

        <el-table border
          :data="goodsInfoData"
          :cell-style="tc"
          :header-cell-style="tccolor"
          size="mini"
          style="width: 100%;margin-top:38px;">
          <el-table-column label="商品图片">
            <template slot-scope="scope">
              <img style="width:36px;height:36px;"
                :src="scope.row.img_url" />
            </template>
          </el-table-column>
          <el-table-column label="商品名称">
            <template slot-scope="scope">
              <p v-if="scope.row.title">
                {{ scope.row.title }}
              </p>
              <p v-else>---</p>
            </template>
          </el-table-column>
          <el-table-column label="来源/供应商">
            <template slot-scope="scope">
              <p v-if="detail.supply_name">来源: {{ detail.supply_name }}</p>
              <p v-else>---</p>
              <p v-if="scope.row.supplier_name">
                供应商: {{ scope.row.supplier_name }}
              </p>
              <p v-else>---</p>
            </template>
          </el-table-column>
          <el-table-column label="接入方式">
            <template slot-scope="scope">
              <p v-if="scope.row.supply_channel_type == 0">
                自营创建
              </p>
              <p v-if="scope.row.supply_channel_type == 1">
                1688接入
              </p>
              <p v-if="scope.row.supply_channel_type == 2">
                供应商接入
              </p>
              <!-- <p v-else>---</p> -->
            </template>
          </el-table-column>
          <el-table-column label="规格属性">
            <template slot-scope="scope">
              <p v-if="scope.row.attribute">
                {{ scope.row.attribute }}
              </p>
              <p v-else>---</p>
            </template>
          </el-table-column>
          <el-table-column label="数量">
            <template slot-scope="scope">
              <p v-if="scope.row.quantity">{{ scope.row.quantity }}件</p>
              <p v-else>---</p>
            </template>
          </el-table-column>
          <el-table-column label="价格">
            <template slot-scope="scope">
              <p v-if="scope.row.unit_price">
                供货价: ¥{{ scope.row.unit_price }}
              </p>
              <p v-else>---</p>

              <p v-if="scope.row.cost_price">
                成本价: ¥{{ scope.row.cost_price }}
              </p>
              <p v-else>---</p>
            </template>
          </el-table-column>

          <el-table-column label="收益预估">
            <template slot-scope="scope">
              <p v-if="
									scope.row.unit_price &&
										scope.row.cost_price &&
										scope.row.quantity
								">
                ¥
                {{
									(
										(Number(scope.row.unit_price) -
											Number(scope.row.cost_price)) *
										Number(scope.row.quantity)
									).toFixed(2)
								}}
              </p>
              <p v-else>---</p>
            </template>
          </el-table-column>
        </el-table>
        <div class="total_profit"
          v-if="goodsInfoData.length > 0">
          <span v-if="goodsInfoData[0].unit_price && goodsInfoData[0].quantity"
            style="color:#f4222d;">¥
            {{
							(
								Number(goodsInfoData[0].unit_price) *
								Number(goodsInfoData[0].quantity)
							).toFixed(2)
						}}</span>
          <span>合计:</span>
        </div>
      </div>

      <div class="order_base_info"
        v-if="detail.order_status != 0 && detail.order_status != 1">
        <div style="margin-bottom:24px;">
          <i class="el-icon-collection-tag"></i>
          <span class="top_title">物流信息</span>
        </div>

        <el-table border
          :data="wuliuData"
          :cell-style="tc"
          :header-cell-style="tccolor"
          size="mini"
          style="width: 100%;margin-top:38px;">
          <el-table-column label="物流公司">
            <template slot-scope="scope">
              <p v-if="scope.row.express_company">
                {{ scope.row.express_company }}
              </p>
              <p v-else>---</p>
            </template>
          </el-table-column>
          <el-table-column label="物流单号">
            <template slot-scope="scope">
              <p v-if="scope.row.express_no">
                {{ scope.row.express_no }}
              </p>
              <p v-else>---</p>
            </template>
          </el-table-column>
          <!-- <el-table-column label="物流费用"> -->
          <!-- <template slot-scope="scope">
							<p v-if="scope.row.supplier_name">
								{{ scope.row.supplier_name }}
							</p>
							<p v-else>---</p>
						</template> -->
          <!-- </el-table-column> -->
          <el-table-column label="发货时间">
            <template slot-scope="scope">
              <p v-if="scope.row.express_send_time">
                {{ scope.row.express_send_time }}
              </p>
              <p v-else>---</p>
            </template>
          </el-table-column>
          <!-- <el-table-column label="物流状态"> -->
          <!-- <template slot-scope="scope">
							<p v-if="scope.row.attribute">
								{{ scope.row.attribute }}
							</p>
							<p v-else>---</p>
						</template> -->
          <!-- </el-table-column> -->
          <el-table-column label="当前物流信息">
            <template slot-scope="scope">
              <p v-if="scope.row.express_remark">{{ scope.row.express_remark }}</p>
              <p v-else>---</p>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div class="order_base_info">
        <div style="margin-bottom:24px;">
          <i class="el-icon-collection-tag"></i>
          <span class="top_title">操作备注</span>
        </div>

        <el-table border
          :data="operateData"
          :cell-style="tc"
          :header-cell-style="tccolor"
          size="mini"
          style="width: 100%;margin-top:38px;">
          <el-table-column label="操作者">
            <template slot-scope="scope">
              <p v-if="scope.row.operator">{{ scope.row.operator }}</p>
              <p v-else>---</p>
            </template>
          </el-table-column>
          <el-table-column label="操作时间"
            prop="created_at"></el-table-column>
          <el-table-column label="订单状态">
            <template slot-scope="scope">
              <p v-if="scope.row.order_status == 0">
                待支付
              </p>
              <p v-if="scope.row.order_status == 1">
                待发货
              </p>
              <p v-if="scope.row.order_status == 2">
                已发货
              </p>

              <p v-if="scope.row.order_status == 7">
                已收货
              </p>
              <p v-if="scope.row.order_status == 6">
                已签收
              </p>

              <p v-if="scope.row.order_status == 3">
                已取消
              </p>
              <p v-if="scope.row.order_status == 4">
                已完成
              </p>
              <p v-if="scope.row.order_status == 5">
                已关闭
              </p>
            </template>
          </el-table-column>
          <el-table-column label="发货状态">
            <template slot-scope="scope">
              <p v-if="scope.row.order_status == 0">
                未发货
              </p>
              <p v-if="scope.row.order_status == 1">
                待发货
              </p>

              <p v-if="scope.row.order_status == 2">
                已发货
              </p>

              <p v-if="scope.row.order_status == 6">
                已签收
              </p>
            </template>
          </el-table-column>
          <el-table-column label="日志备注"
            prop="remark"></el-table-column>
        </el-table>
      </div>
    </div>

    <gydialog title="备注订单"
      :visible.sync="showCreateRemark"
      width="600px">
      <div style="padding:20px;overflow:hidden;">
        <div style="float:left;width:120px;">
          <span style="color:#f4222d;margin-right:6px;">*</span><span>操作备注:</span>
        </div>
        <el-input type="textarea"
          :rows="3"
          style="width:300px;float:left;"
          placeholder="请输入内容"
          v-model="remark">
        </el-input>
      </div>

      <div style="border-top:1px solid rgb(228, 228, 228);height:60px;">
        <el-button size="mini"
          type="primary"
          style="float:right;margin-right:20px;margin-top:18px;"
          @click="certainCreateRemark">确定</el-button>
        <el-button size="mini"
          style="float:right;margin-right:12px;margin-top:18px;"
          @click="showCreateRemark = !showCreateRemark">取消</el-button>
      </div>
    </gydialog>

    <!--确认发货-->
    <gydialog :title="wuliuTitle"
      :visible.sync="showWuliuOrChange"
      width="640px;">
      <div style="padding:20px 30px;">
        <table class="after_table">
          <tr>
            <td class="people_info"
              colspan="3">收件人信息</td>
            <!-- <td></td> -->
          </tr>
          <tr>
            <td>收件人</td>
            <td>
              <p v-if="order_express_detail.contact_name">
                {{ order_express_detail.contact_name }}
              </p>
              <p v-else>---</p>
            </td>
          </tr>
          <tr>
            <td>联系电话</td>
            <td>
              <p v-if="order_express_detail.contact_phone">
                {{ order_express_detail.contact_phone }}
              </p>
              <p v-else>---</p>
            </td>
          </tr>
          <tr>
            <td>收件地址</td>
            <td>
              <p v-if="order_express_detail.address">
                {{ order_express_detail.province }}.{{
									order_express_detail.city
								}}.{{ order_express_detail.area }}.{{
									order_express_detail.address
								}}
              </p>
              <p v-else>---</p>
            </td>
          </tr>
          <tr>
            <td class="people_info"
              colspan="2">物流信息</td>
          </tr>
          <tr>
            <td>快递公司</td>
            <td>
              <el-select size="mini"
                v-model="expressform.express_company_code">
                <el-option v-for="(item, index) in expressCode"
                  :key="'c' + index"
                  :label="item.value"
                  :value="item.code">
                </el-option>
              </el-select>
            </td>
          </tr>
          <tr>
            <td>快递单号</td>
            <td>
              <el-input size="mini"
                v-model="expressform.express_no"
                placeholder="请输入快递单号"></el-input>
            </td>
          </tr>
          <!-- <tr>
						<td>物流寄送类型</td>
						<td></td>
					</tr> -->
        </table>
      </div>

      <div style="margin:18px 20px;height:40px;">
        <el-button size="mini"
          @click="updateExpressInfo"
          style="float:right;margin-right:12px;"
          type="warning">确定</el-button>
        <el-button size="mini"
          @click="cancelExpressInfo"
          style="float:right;margin-right:12px;">取消</el-button>
      </div>
    </gydialog>

    <!--物流轨迹跟踪-->
    <gydialog title="物流轨迹跟踪"
      :visible.sync="showTrackDialog"
      width="640px">
      <div style="padding:18px 24px">
        <el-timeline>
          <el-timeline-item v-for="(activity, index) in activities"
            :key="index"
            :icon="activity.icon"
            :type="activity.type"
            :color="activity.color"
            :size="activity.size">
            <div class="timeline-content">{{ activity.content }}</div>
            <div class="timeline-content">{{ activity.timestamp }}</div>
          </el-timeline-item>
        </el-timeline>
      </div>
    </gydialog>

    <!--申请维权-->
    <gydialog title="申请维权"
      :visible.sync='showApplyOrder'
      width='720px'>

      <table class="after_table">
        <tr>
          <td>订单编号</td>
          <td>{{detail.order_no}}</td>
        </tr>
        <tr>
          <td>联系方式</td>
          <td>
            <el-input size="mini"
              style="width:270px;"
              v-model="apply_order_info.contact_phone"
              placeholder="请输入联系方式"></el-input>
          </td>
        </tr>
        <tr>
          <td>退款金额</td>
          <td>
            <el-input size="mini"
              style="width:270px;"
              v-model="apply_order_info.refund_money"
              placeholder="请输入退款金额"></el-input>
          </td>
        </tr>

        <tr>
          <td>申请原因</td>
          <td>
            <el-input size="mini"
              style="width:270px;"
              v-model="apply_order_info.apply_reason"
              placeholder="请输入申请原因"></el-input>
          </td>
        </tr>
        <tr class="refund_reason">
          <td>退款原因</td>
          <td>
            <el-radio-group v-model="apply_order_info.apply_reason_id">
              <el-radio :label="1">
                <span class='radio_label'>不喜欢/不想要/效果不好</span>
              </el-radio>
              <el-radio :label="2"><span class='radio_label'>拍错了</span></el-radio>
              <el-radio :label="3"><span class='radio_label'>未按照约定时间发货</span></el-radio>
              <el-radio :label="4"><span class='radio_label'>质量问题</span></el-radio>
              <el-radio :label="5"><span class='radio_label'>颜色/样式/尺寸大小与描述不符</span></el-radio>
              <el-radio :label="6"><span class='radio_label'>卖家发错货</span></el-radio>
              <el-radio :label="7"><span class='radio_label'>配件破损</span></el-radio>
              <el-radio :label="8"><span class='radio_label'>主商品破损</span></el-radio>
              <el-radio :label="9"><span class='radio_label'>其他</span></el-radio>
            </el-radio-group>
          </td>
        </tr>
        <tr class="pic_tab">
          <td>图片</td>
          <td>
            <uploadImg flieName="icon"
              class="text_left"
              :n="4"
              @getFile="getFile"></uploadImg>
            <span style="color:#999;font-size:12px;">支持png、jpg格式图片，大小不超过1M</span>
          </td>
        </tr>
        <tr>
          <td>备注</td>
          <td>
            <el-input type="textarea"
              :rows="2"
              style="width:300px;"
              placeholder="请输入内容"
              v-model="apply_order_info.remark">
            </el-input>
          </td>
        </tr>
      </table>

      <div style="margin:20px;padding-bottom:20px;padding-right:20px;">
        <el-button type="primary"
          size="mini"
          style='float:right;margin-left:12px;'
          @click="applyAfterSaleInOrder">申请维权</el-button>
        <el-button size="mini"
          style='float:right;'
          @click="cancelApply">取消</el-button>
      </div>
    </gydialog>
  </div>
</template>
<script>
import uploadImg from '@/components/uploadImg'
import {
  orderDetailInfo,
  orderRemarkCreate,
  closeOrder,
  expressCompanyList,
  updateExpress,
  expressLogisticsTrace,
  applyRefundAfterSale
} from '@/api/order'

export default {
  components: {
    uploadImg
  },
  data () {
    return {
      orderId: '',
      detail: {},
      order_express_detail: {},
      baseInfoData: [],
      userInfoData: [],
      goodsInfoData: [],
      operateData: [],
      wuliuForm: {},
      wuliuData: [],

      //备注订单
      showCreateRemark: false,
      remark: '',
      order_step: 3,
      stepList: [
        { title: '提交订单' },
        { title: '支付订单' },
        { title: '平台发货' },
        { title: '物流配送' },
        { title: '完成订单' }
      ],
      wuliuTitle: '确认发货',
      showWuliuOrChange: false,
      expressCode: [],
      expressform: {
        express_company: '',
        express_no: '',
        express_company_code: ''
      },

      activities: [],
      showTrackDialog: false,

      //申请维权
      showApplyOrder: false,
      applyRefundForm: {
        imgs: ''
      },

      products: {
        product_id: '',
        sku_id: '',
        quantity: '',
      },
      apply_order_info: {
        refund_money: '',
        contact_phone: '',
        apply_reason_id: '',
        apply_reason: '',
        order_no: '',
        remark: ''
      }
    }
  },
  activated () {
    this.orderId = this.$route.query.orderId
    if (this.orderId) {
      this.orderDetailInfoData()
      this.expressCompanyListData()
      // this.orderRemarkListData()
    }
  },
  methods: {
    //确认发货
    certainPushWoods () {
      this.showWuliuOrChange = true
    },
    //获取订单详情
    async orderDetailInfoData () {
      let res = await orderDetailInfo(this.orderId)

      this.baseInfoData = []
      this.userInfoData = []
      this.goodsInfoData = []
      this.operateData = []
      this.wuliuForm = {}
      this.wuliuData = []
      // 物流轨迹数据
      this.activities = []
      this.detail = res

      if (res.order_status == 0) {
        this.order_step = 1
      } else if (res.order_status == 1) {
        this.order_step = 2
      } else if (res.order_status == 2) {
        this.order_step = 3
      } else if (res.order_status == 6 || res.order_status == 7) {
        this.order_step = 4
      } else {
        this.order_step = 5
      }
      this.baseInfoData.push({
        order_no: res.order_no,
        buyer_phone: res.buyer_phone,
        created_at: res.created_at,
        moeny_pay: res.order_pay ? res.order_pay.money_pay : '',
        pay_way: '',
        partner_name: res.partner_name,
        agency_name: res.agency_name,
        money_total: res.order_pay ? res.order_pay.money_total : '',
        money_carriage: res.order_pay ? res.order_pay.money_carriage : '',
      })
      if (res.order_express && res.order_express.length > 0) {
        this.order_express_detail = res.order_express[0]
        this.expressform.express_company = res.order_express[0].express_company
        this.expressform.express_no = res.order_express[0].express_no
        this.expressCode.map(item => {
          if (item.value == res.order_express[0].express_company) {
            this.expressform.express_company_code = item.code
          }
        })
        if(!this.expressform.express_company_code){
          this.expressform.express_company_code = res.order_express[0].express_company_code
        }
        this.userInfoData.push(res.order_express[0])
        this.wuliuForm.express_company = res.order_express[0].express_company
        this.wuliuForm.express_no = res.order_express[0].express_no

      } else {
        this.userInfoData.push({
          contact_name: '',
          contact_phone: '',
          code: '',
          address: '',
          city: '',
          province: '',
          area: ''
        })
        this.wuliuForm.express_company = ''
        this.wuliuForm.express_no = ''
      }
      this.wuliuForm.express_send_time = res.express_send_time
      // this.operateData = res.order_remark
      // if (res.order_remark.length > 0) {
      //   this.wuliuForm.express_status =
      //     res.order_remark[res.order_remark.length - 1].express_status
      // } else {
      //   this.wuliuForm.express_status = ''
      // }
      if (this.detail.order_status == 7 || this.detail.order_status == 4 || this.detail.order_status == 2 || this.detail.order_status == 6 || this.detail.order_status == 5) {
        this.expressLogisticsTraceData()
      }


      //获取当前物流状态和物流信息

      if (res.order_product) {
        this.goodsInfoData.push(res.order_product[0])
      }
      this.operateData = res.order_remark
    },
    createRemark () {
      this.remark = ''
      this.showCreateRemark = true
    },
    certainCreateRemark () {
      if (!this.remark) {
        this.$message.error('备注内容不能为空')
        return
      }
      this.orderRemarkCreateData()
    },

    //跟踪物流轨迹
    trackWuliuInfo () {
      this.showTrackDialog = true
      this.expressLogisticsTraceData()
    },
    async orderRemarkCreateData () {
      let res = await orderRemarkCreate({
        order_id: this.orderId,
        remark: this.remark
      })
      console.log(res)
      this.$message.success('创建备注成功')
      // this.orderRemarkListData()
      this.orderDetailInfoData()
      this.showCreateRemark = false
    },

    //关闭订单
    endOrder () {
      this.$confirm('确定关闭该订单?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.closeOrderData()
        })
        .catch(error => {
          console.log(error)
        })
    },
    async closeOrderData () {
      let res = await closeOrder(this.orderId)
      console.log(res)
      this.$message.success('关闭订单成功')
      this.orderDetailInfoData()
    },
    //获取物流公司列表
    async expressCompanyListData () {
      let res = await expressCompanyList()
      this.expressCode = []
      for (let key in res) {
        let obj = {}
        obj['code'] = key
        obj['value'] = res[key]
        this.expressCode.push(obj)
      }
      console.log(this.expressCode)
    },

    //更新物流信息
    updateExpressInfo () {
      if (!this.expressform.express_company_code) {
        this.$message.error('物流公司不能为空')
        return
      }
      if (!this.expressform.express_no) {
        this.$message.error('物流单号不能为空')
        return
      }
      this.expressCode.map(item => {
        if (item.code == this.expressform.express_company_code) {
          this.expressform.express_company = item.value
        }
      })
      updateExpress(this.orderId, this.expressform).then(res => {
        console.log(res)
        this.$message.success('操作成功')
        this.orderDetailInfoData()
        this.showWuliuOrChange = false
      })
    },

    //取消物流消息
    cancelExpressInfo () {
      this.showWuliuOrChange = false
    },

    //获取物流轨迹
    async expressLogisticsTraceData () {

      let res = await expressLogisticsTrace({ express_company_code: this.expressform.express_company_code, express_no: this.wuliuForm.express_no })
      if (res.length > 0) {

        res.map((item, index) => {
          this.activities.push({ content: item.AcceptStation, timestamp: item.AcceptTime })

          if (index == 0) {
            this.wuliuData = []
            this.wuliuForm.express_remark = item.AcceptStation
            this.wuliuData.push(this.wuliuForm)
          }

        })
      } else {
        this.wuliuData = []
        this.wuliuForm.express_remark = ''
        this.wuliuData.push(this.wuliuForm)
      }



      // this.activities = [{ content: '订单已签收,期待再次为您服务', timestamp: '2017-04-01 12:00:00' }]
    },

    //申请维权
    applyAferSale () {
      this.showApplyOrder = true
      this.products.product_id = this.detail.product_id
      this.products.sku_id = this.detail.sku_id
      this.products.quantity = this.detail.quantity
      this.applyRefundForm.imgs = []
      this.apply_order_info = {
        refund_money: '',
        contact_phone: '',
        apply_reason_id: '',
        apply_reason: '',
        order_no: this.apply_order_info.order_no,
        remark: ''
      }
    },
    applyAfterSaleInOrder () {
      if (!this.apply_order_info.refund_money) {
        this.$message.error('请填写退款金额')
        return
      }
      if (!this.apply_order_info.contact_phone) {
        this.$message.error('请填写联系方式')
        return
      }
      if (!this.apply_order_info.apply_reason_id) {
        this.$message.error('请选择退款原因')
        return
      }

      if (!this.apply_order_info.apply_reason) {
        this.$message.error('请填写申请原因')
        return
      }
      this.apply_order_info.order_no = this.detail.order_no
      applyRefundAfterSale({ products: JSON.stringify([this.products]), images: JSON.stringify(this.applyRefundForm.imgs), order_info: JSON.stringify(this.apply_order_info) }).then(() => {
        this.$message.success('申请成功')
        this.showApplyOrder = false
        this.orderDetailInfoData()
      })
    },
    cancelApply () {
      this.showApplyOrder = false
    },
    getFile (file) {
      if (file.files.length > 0) {
        file.files.map(item => {
          this.applyRefundForm.imgs.push(item.url)
        })
      } else {
        this.applyRefundForm.imgs = []
      }
    },
    tc () {
      return 'text-align:center;'
    },
    tccolor () {
      return 'text-align:center;background-color:#f5f5f5; font-size:14px;font-weight:500;color:rgb(102,102,102);'
    }
  }
}
</script>
<style lang="scss" scoped>
.container {
	.order_detail_top {
		background-color: rgb(240, 242, 245);
		padding: 20px;
		height: 120px;
	}
	.main_order_detail {
		margin: 25px 12px;
		border: 1px solid rgb(228, 228, 228);
		.order_status {
			background-color: rgb(243, 243, 243);
			height: 72px;
			line-height: 72px;
			i {
				color: #f4222d;
				font-size: 16px;
				float: left;
				margin-top: 27px;
				margin-left: 24px;
			}
			.current_order_status {
				float: left;
				font-size: 18px;
				color: rgb(237, 103, 102);
				font-weight: 500;
			}
		}
		.order_base_info {
			margin: 36px 20px 0 20px;
			overflow: hidden;
			i {
				color: rgb(51, 51, 51);
				float: left;
				margin-top: 4px;
				font-size: 20px;
				font-weight: 500;
			}
			.top_title {
				float: left;
				font-weight: 500;
				font-size: 18px;
			}
		}
	}
	.total_profit {
		background-color: rgb(240, 242, 245);
		height: 42px;
		line-height: 42px;
		span {
			float: right;
			margin-right: 12px;
			font-weight: 500;
			font-size: 16px;
		}
	}
	.el-steps {
		height: 72px;
	}

	.after_table {
		border: 1px solid rgb(228, 228, 228);
		margin: 20px 28px;
		border-collapse: collapse;
		width: 90%;
		.pic_tab {
			height: 60px;
		}
		.refund_reason {
			height: 100px;
		}
		tr {
			height: 48px;
			td {
				border: 1px solid rgb(228, 228, 228);
				padding: 10px;
				font-size: 13px;
			}
			td:first-child {
				background-color: rgb(249, 250, 252);
				width: 160px;
				text-align: right;
				padding-right: 24px;
				font-weight: 500;
			}
			td:last-child {
				text-align: left;
				padding-left: 24px;
			}
		}
		tr:last-child {
			height: 72px;
		}
	}

	.el-timeline-item {
		text-align: left;
	}

	.timeline-content {
		color: #999;
		font-size: 12px;
		margin-bottom: 4px;
	}
	.radio_label {
		font-size: 12px;
	}
}
</style>
